import { Component, OnDestroy } from "@angular/core";
import {PriceyardService} from '../../modules/priceyard/services/priceyard.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-buy-box-cell-editor",
  templateUrl: "./buy-box-cell-editor.component.html",
  styleUrls: ["./buy-box--cell-editor.component.scss"],
})
export class BuyBoxCellEditorComponent implements OnDestroy {
  params: any;
  amount: number;
  private destroy$ = new Subject<void>();
  
  constructor(private priceyardService: PriceyardService,
              private snackBar: MatSnackBar) {}

  agInit(params: any): void {
    this.params = params;
    this.amount = this.params.data[this.params.priceProp];
  }

  save(): void {
    const payload = {
      sku: this.params.data.Sku,
      account: this.params.data.Account,
      fulfillmentType: this.params.data.FulfillmentType,
      changingFactors: [{ value: this.amount, factor: "Min Price" }],
    };
    this.priceyardService.changePriceFactor([payload]).pipe(takeUntil(this.destroy$)).subscribe((response) => {
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Min Price updated successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      this.params.api.refreshServerSide({});
    });
    this.params.stopEditing();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
